import React, { useState } from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
  DialogFooter,
} from "./ui/dialog";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import "../styles/datePicker.css"
import { Button } from "./ui/button";
import { format } from "date-fns";
import { Separator } from "./ui/separator";

export default function InvestDateRange({
  onDateRangeClose,
  openDateRangeModal,
  setOpenDateRangeModal,
  customEnd,
  customStart,
}) {
  const [startDate, setStartDate] = useState(customStart);
  const [endDate, setEndDate] = useState(customEnd);

  const formatDate = (date) => (date ? format(date, "PPP") : "");
  const handleDialogChange = (isOpen) => {
    setOpenDateRangeModal(isOpen);
    if (!isOpen) {
      onDateRangeClose?.();
    }
  };
  return (
    <Dialog open={openDateRangeModal} onOpenChange={handleDialogChange}>
      <DialogContent className="sm:max-w-[700px]">
        <DialogHeader>
          <DialogTitle>Custom Date Range</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col md:flex-row gap-6 mt-4">
          <div className="flex flex-col w-full max-w-[242px] mx-auto">
            <label className="text-sm text-gray-600 mb-2">Start Date</label>
            <input
              type="text"
              value={formatDate(startDate)}
              readOnly
              className="w-full px-4 py-2 mb-2 border rounded-md text-sm bg-gray-100"
            />
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              inline
              calendarClassName="!w-full !m-0 custom-datepicker"
            />
          </div>

          {/* End Date */}
          <div className="flex flex-col w-full max-w-[242px] mx-auto">
            <label className="text-sm text-gray-600 mb-2">End Date</label>
            <input
              type="text"
              value={formatDate(endDate)}
              readOnly
              className="w-full px-4 py-2 mb-2 border rounded-md text-sm bg-gray-100"
            />
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              inline
              calendarClassName="!w-full !m-0 custom-datepicker"
            />
          </div>
        </div>
        <Separator />
        <div className="flex items-center justify-center gap-4">
          <Button
            onClick={() => {
              onDateRangeClose?.();
            }}
            variant="outline"
            className="py-3 px-20 text-sm font-bold text-black border border-gray-300 rounded-full bg-white hover:opacity-90"
          >
            Cancel
          </Button>

          <Button
            onClick={() => {
              onDateRangeClose?.({ startDate, endDate });
            }}
            className="py-3 px-20 text-sm font-bold text-white rounded-full bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90"
          >
            Save changes
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
